'use strict';

var React = require('react');
var Chip = require('../Chip');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Chip__default = /*#__PURE__*/_interopDefaultLegacy(Chip);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".carousel-module_carousel-wrapper__LLzDa {\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  justify-content: center;\n  display: flex;\n  position: relative;\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12) {\n  background-color: rgba(255, 255, 255, 0.5);\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);\n  transition: all 0.25s;\n  color: #000;\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12).carousel-module_prev__qMH5- {\n  background-image: url(https://cdn0.iconfinder.com/data/icons/navigation-set-arrows-part-one/32/ChevronLeft-512.png);\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12).carousel-module_next__1Kj2o {\n  background-image: url(https://cdn0.iconfinder.com/data/icons/navigation-set-arrows-part-one/32/ChevronRight-512.png);\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12).carousel-module_round__3Lnim {\n  background-image: none;\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12).carousel-module_round__3Lnim svg {\n  display: block;\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12).carousel-module_legacy__2EMqv {\n  width: 32px;\n  height: 32px;\n  border-radius: 50px;\n  box-shadow: none;\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12):focus {\n  box-shadow: 0 0 0 2px #d63426;\n  background-color: #fff;\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12):focus.carousel-module_prev__qMH5- {\n  background-image: url(https://cdn0.iconfinder.com/data/icons/navigation-set-arrows-part-one/32/ChevronLeft-512.png);\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12):focus.carousel-module_next__1Kj2o {\n  background-image: url(https://cdn0.iconfinder.com/data/icons/navigation-set-arrows-part-one/32/ChevronRight-512.png);\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12):focus.carousel-module_round__3Lnim {\n  background-image: none;\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12):focus.carousel-module_round__3Lnim svg {\n  display: block;\n  background-color: rgba(255, 255, 255, 0);\n}\n.carousel-module_carousel-wrapper__LLzDa:hover > .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2:not(.carousel-module_disable-controls__ZVx12):focus.carousel-module_round__3Lnim svg circle {\n  stroke: rgba(255, 255, 255, 0.5);\n  fill: rgba(255, 255, 255, 0.5);\n}\n.carousel-module_carousel-wrapper-slider__3TPu4 {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n.carousel-module_carousel-wrapper-slides__LgUqO {\n  display: flex;\n  position: relative;\n  top: 0;\n}\n.carousel-module_carousel-wrapper-slides__LgUqO.carousel-module_shifting__2nmSs {\n  transition: left 0.2s ease-out;\n}\n.carousel-module_carousel-wrapper-slides__LgUqO .carousel-module_slide__1zbI4 {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  min-height: 150px;\n  cursor: grab;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  transition: left 1s;\n  position: relative;\n  border-radius: 2px;\n  white-space: nowrap;\n}\n.carousel-module_carousel-wrapper-slides__LgUqO.carousel-module_marginless__2QMie {\n  margin: 0;\n}\n.carousel-module_carousel-wrapper-slides__LgUqO .carousel-module_chip-slide__9PgRo {\n  min-height: 50px;\n  white-space: nowrap;\n}\n.carousel-module_carousel-wrapper-slides__LgUqO .carousel-module_chip-slide__9PgRo button[class^=chip-module--chip] {\n  margin: 0;\n}\n.carousel-module_carousel-wrapper-slides__LgUqO .carousel-module_grabbing__2wC24 {\n  cursor: grabbing;\n}\n.carousel-module_carousel-wrapper-control__3WnBL {\n  position: absolute;\n  top: 50%;\n  width: 50px;\n  height: 50px;\n  background: #fff;\n  border-radius: 50px;\n  border: none;\n  margin-top: -20px;\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);\n  z-index: 2;\n  outline: none;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_mt-adjust__3mR5Q {\n  margin-top: -48px;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_mt-adjust__3mR5Q.carousel-module_legacy__2EMqv {\n  margin-top: -41px;\n}\n.carousel-module_carousel-wrapper-control__3WnBL svg {\n  width: 100%;\n  height: 100%;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_prev__qMH5-, .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_next__1Kj2o {\n  width: 35px;\n  background-size: 22px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_prev__qMH5- {\n  border-radius: 0 5px 5px 0;\n  background-image: url(https://cdn0.iconfinder.com/data/icons/navigation-set-arrows-part-one/32/ChevronLeft-512.png);\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_next__1Kj2o {\n  border-radius: 5px 0 0 5px;\n  background-image: url(https://cdn0.iconfinder.com/data/icons/navigation-set-arrows-part-one/32/ChevronRight-512.png);\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_prev__qMH5-:active, .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_next__1Kj2o:active {\n  transform: scale(0.8);\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_round__3Lnim {\n  background-image: none;\n  width: 50px;\n  display: flex;\n  align-items: center;\n  border-radius: 50px;\n  padding: 0px;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_round__3Lnim svg {\n  display: block;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_round__3Lnim.carousel-module_prev__qMH5- {\n  transform: rotate(180deg) scaleX(-1);\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_round__3Lnim.carousel-module_next__1Kj2o {\n  transform: rotate(180deg);\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_legacy__2EMqv {\n  width: 32px;\n  height: 32px;\n  border-radius: 50px;\n  box-shadow: none;\n  border: 2px solid #f7f7f7;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2 {\n  background-image: none;\n  background-color: rgba(255, 255, 255, 0);\n  box-shadow: none;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2 svg {\n  display: none;\n  background-color: rgba(255, 255, 255, 0);\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2 svg circle {\n  stroke: rgba(255, 255, 255, 0.5);\n  fill: rgba(255, 255, 255, 0.5);\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_hidden___6cv2.carousel-module_legacy__2EMqv {\n  border: none;\n}\n.carousel-module_carousel-wrapper-control__3WnBL:focus:not(.carousel-module_disable-controls__ZVx12) {\n  box-shadow: 0 0 0 2px #d63426;\n  background-color: #fff;\n}\n.carousel-module_carousel-wrapper-control__3WnBL:focus:not(.carousel-module_disable-controls__ZVx12).carousel-module_prev__qMH5- {\n  background-image: url(https://cdn0.iconfinder.com/data/icons/navigation-set-arrows-part-one/32/ChevronLeft-512.png);\n}\n.carousel-module_carousel-wrapper-control__3WnBL:focus:not(.carousel-module_disable-controls__ZVx12).carousel-module_next__1Kj2o {\n  background-image: url(https://cdn0.iconfinder.com/data/icons/navigation-set-arrows-part-one/32/ChevronRight-512.png);\n}\n.carousel-module_carousel-wrapper-control__3WnBL:focus:not(.carousel-module_disable-controls__ZVx12).carousel-module_round__3Lnim {\n  background-image: none;\n}\n.carousel-module_carousel-wrapper-control__3WnBL:focus:not(.carousel-module_disable-controls__ZVx12).carousel-module_round__3Lnim svg {\n  display: block;\n  background-color: rgba(255, 255, 255, 0);\n}\n.carousel-module_carousel-wrapper-control__3WnBL:focus:not(.carousel-module_disable-controls__ZVx12).carousel-module_round__3Lnim svg circle {\n  stroke: rgba(255, 255, 255, 0.5);\n  fill: rgba(255, 255, 255, 0.5);\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_center__3hAS4.carousel-module_next__1Kj2o {\n  right: 40%;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_center__3hAS4.carousel-module_prev__qMH5- {\n  left: 40%;\n}\n@media only screen and (max-width: 767px) {\n  .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_center__3hAS4.carousel-module_next__1Kj2o {\n    right: 30%;\n  }\n  .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_center__3hAS4.carousel-module_prev__qMH5- {\n    left: 30%;\n  }\n}\n@media only screen and (max-width: 425px) {\n  .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_center__3hAS4.carousel-module_next__1Kj2o {\n    right: 25%;\n  }\n  .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_center__3hAS4.carousel-module_prev__qMH5- {\n    left: 25%;\n  }\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_left__1YHGw.carousel-module_next__1Kj2o {\n  left: 10%;\n}\n@media only screen and (max-width: 767px) {\n  .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_left__1YHGw.carousel-module_next__1Kj2o {\n    left: 20%;\n  }\n}\n@media only screen and (max-width: 425px) {\n  .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_left__1YHGw.carousel-module_next__1Kj2o {\n    left: 25%;\n  }\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_left__1YHGw.carousel-module_prev__qMH5- {\n  left: 1%;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_right__2tRwR.carousel-module_next__1Kj2o {\n  right: 1%;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_right__2tRwR.carousel-module_prev__qMH5- {\n  right: 10%;\n}\n@media only screen and (max-width: 767px) {\n  .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_right__2tRwR.carousel-module_prev__qMH5- {\n    right: 20%;\n  }\n}\n@media only screen and (max-width: 425px) {\n  .carousel-module_carousel-wrapper-control__3WnBL.carousel-module_right__2tRwR.carousel-module_prev__qMH5- {\n    right: 25%;\n  }\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_apart__2Ob_c.carousel-module_next__1Kj2o {\n  right: 0px;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_apart__2Ob_c.carousel-module_prev__qMH5- {\n  left: 0px;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_top__19Z8- {\n  top: 5%;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_disable-controls__ZVx12 {\n  top: -50%;\n}\n.carousel-module_carousel-wrapper-control__3WnBL.carousel-module_bottom__k6MCX {\n  top: 70%;\n}\n.carousel-module_carousel-wrapper-control__3WnBL:disabled {\n  cursor: not-allowed;\n  opacity: 60%;\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD {\n  display: flex;\n  width: fit-content;\n  flex-direction: row;\n  justify-content: center;\n  margin: 5px auto;\n  padding: 12px;\n  cursor: pointer;\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD.carousel-module_dark__3v9yx {\n  background-color: #2d2926;\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD .carousel-module_indicator-button__3IGb2 {\n  margin: 0 5px;\n  outline: none;\n  background-color: #b3b5b7;\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD .carousel-module_indicator-button__3IGb2.carousel-module_round__3Lnim {\n  width: 10px;\n  height: 10px;\n  box-sizing: content-box;\n  border-radius: 50%;\n  border: 2px solid #b3b5b7;\n  padding: 0;\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD .carousel-module_indicator-button__3IGb2.carousel-module_bar__3jX5F {\n  height: 5px;\n  width: 5px;\n  border: 2px solid #b3b5b7;\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD .carousel-module_indicator-button__3IGb2:hover {\n  background-color: #b3b5b7;\n  border-color: #d63426;\n  border: 2px solid #d63426;\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD .carousel-module_indicator-button__3IGb2[data-selected=true] {\n  background-color: #d63426;\n  border-color: #d63426;\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD .carousel-module_indicator-button__3IGb2:active {\n  transform: scale(0.8);\n}\n.carousel-module_carousel-wrapper-indicators__2f1gD .carousel-module_indicator-button__3IGb2:focus {\n  border-color: #d63426;\n}\n.carousel-module_carousel-wrapper__LLzDa .carousel-module_sr-only__2d3t_ {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}";
var styles = {"carousel-wrapper":"carousel-module_carousel-wrapper__LLzDa","carousel-wrapper-control":"carousel-module_carousel-wrapper-control__3WnBL","hidden":"carousel-module_hidden___6cv2","disable-controls":"carousel-module_disable-controls__ZVx12","prev":"carousel-module_prev__qMH5-","next":"carousel-module_next__1Kj2o","round":"carousel-module_round__3Lnim","legacy":"carousel-module_legacy__2EMqv","carousel-wrapper-slider":"carousel-module_carousel-wrapper-slider__3TPu4","carousel-wrapper-slides":"carousel-module_carousel-wrapper-slides__LgUqO","shifting":"carousel-module_shifting__2nmSs","slide":"carousel-module_slide__1zbI4","marginless":"carousel-module_marginless__2QMie","chip-slide":"carousel-module_chip-slide__9PgRo","grabbing":"carousel-module_grabbing__2wC24","mt-adjust":"carousel-module_mt-adjust__3mR5Q","center":"carousel-module_center__3hAS4","left":"carousel-module_left__1YHGw","right":"carousel-module_right__2tRwR","apart":"carousel-module_apart__2Ob_c","top":"carousel-module_top__19Z8-","bottom":"carousel-module_bottom__k6MCX","carousel-wrapper-indicators":"carousel-module_carousel-wrapper-indicators__2f1gD","dark":"carousel-module_dark__3v9yx","indicator-button":"carousel-module_indicator-button__3IGb2","bar":"carousel-module_bar__3jX5F","sr-only":"carousel-module_sr-only__2d3t_"};
styleInject(css_248z,{"insertAt":"top"});

function getChildrenArr(children, chips) {
    const cloneEls = [];
    if (chips && chips.list && chips.list.length > 0) {
        const { list, onClick: parentOnClick } = chips, parentRest = __rest(chips, ["list", "onClick"]);
        list.map((_a) => {
            var { label, value, onClick } = _a, rest = __rest(_a, ["label", "value", "onClick"]);
            if (!onClick) {
                onClick = parentOnClick;
            }
            if (Object.keys(rest).length <= 0) {
                rest = parentRest;
            }
            cloneEls.push(React__default['default'].createElement(Chip__default['default'], Object.assign({ key: label, label: label, variant: "default", onClick: () => {
                    if (onClick) {
                        onClick(value);
                    }
                } }, rest)));
        });
    }
    else {
        React.Children.map(children, (child) => {
            if (child) {
                cloneEls.push(child);
            }
        });
    }
    return cloneEls;
}
function getDynamicMeasurements(current, slidePxWidth, slideGap) {
    let dynamicIndexLimit = -1;
    let slidesLength = 0;
    let slideWidthArray = [];
    const nodeLength = current && current.children && current.children.length;
    for (let i = 0; i < nodeLength; i++) {
        let slideLength = current.children[i].getBoundingClientRect().width + slideGap;
        slidesLength += slideLength;
        slideWidthArray.push(slideLength);
    }
    let remainingSlideLength = slidesLength - slideWidthArray[0]; // always remove the first slide
    for (let i = 1; i < slideWidthArray.length; i++) {
        let slideLength = remainingSlideLength - slideWidthArray[i];
        if (dynamicIndexLimit === -1 && slideLength <= slidePxWidth) {
            dynamicIndexLimit = i;
            break;
        }
        remainingSlideLength = slideLength;
    }
    const shiftEnabled = slidePxWidth < slidesLength;
    return { dynamicIndexLimit, slideWidthArray, shiftEnabled };
}
function getSliderMeasurements(current, slideGap, infinite, showHalfSlides, baseSlideCount, slidesShown, dynamic) {
    const measurements = {
        slidesPxWidth: current && current.offsetWidth,
        slidesLeft: 0,
        slideMargin: 0,
        slidePxWidth: 0,
        slideFlexBasis: 0,
        slideFlexPxWidth: 0,
        slideShift: 0,
        dynamic: {
            dynamicIndexLimit: 0,
            lengthArray: [0],
            shiftEnabled: false
        }
    };
    let totalSlideCount = baseSlideCount + (infinite ? 2 : 0) * slidesShown;
    measurements.slidePxWidth = measurements.slidesPxWidth / totalSlideCount;
    if (dynamic) {
        const { dynamicIndexLimit, shiftEnabled, slideWidthArray } = getDynamicMeasurements(current, measurements.slidePxWidth, slideGap);
        measurements.dynamic.lengthArray = slideWidthArray;
        measurements.dynamic.shiftEnabled = shiftEnabled;
        measurements.dynamic.dynamicIndexLimit = dynamicIndexLimit;
        measurements.slideMargin = slideGap;
    }
    else if (slideGap === 0) {
        measurements.slideFlexBasis = 100 / totalSlideCount;
        measurements.slideShift = 100 / slidesShown;
        measurements.slidesLeft = infinite ? -100 / slidesShown + (-100 / slidesShown) * (slidesShown - 1) : 0;
    }
    else {
        let flexBasisPercent = 0.9;
        measurements.slideFlexPxWidth = measurements.slidePxWidth * flexBasisPercent;
        measurements.slideFlexBasis = 90 / totalSlideCount;
        let maxScreenPxWidth = 2560;
        let scaleFactor = measurements.slidesPxWidth / maxScreenPxWidth;
        let defaultMarginPixel = slideGap * scaleFactor;
        measurements.slideMargin = (defaultMarginPixel / measurements.slidesPxWidth) * 100;
        measurements.slideShift =
            (((measurements.slideFlexPxWidth + defaultMarginPixel * 2) / measurements.slidePxWidth) * 100) / slidesShown;
        let remainingWidthPx = measurements.slidePxWidth - measurements.slideFlexPxWidth;
        let offsetLeftPx = remainingWidthPx / 2 - defaultMarginPixel;
        let startPos = (offsetLeftPx / measurements.slidePxWidth) * 100;
        measurements.slidesLeft = infinite ? startPos - measurements.slideShift * slidesShown : startPos;
    }
    if (showHalfSlides && dynamic) {
        measurements.slidesLeft =
            ((measurements.slidePxWidth - (measurements.dynamic.lengthArray[0] - slideGap)) / 2 / measurements.slidePxWidth) *
                100;
    }
    return Object.assign({}, measurements);
}
function getNumberOfIndicators(baseSlideCount, slidesShown, infinite) {
    var count = 1;
    for (var i = baseSlideCount; 0 < i; i--) {
        if (i % slidesShown === 0 && slidesShown === i)
            break;
        count++;
    }
    return count + (infinite ? slidesShown - 1 : 0);
}
function getIndicators(indicatorsLength, baseSlideCount, slidesShown, childrenArr, indicatorStyle, shiftSlide) {
    if (baseSlideCount < 1)
        return [];
    let initIndicators = [];
    let copy = childrenArr.slice();
    copy.splice(0, indicatorsLength).forEach((value, index) => {
        let baseIndex = index + 1;
        let slidesLabel = `Go to slide ${baseIndex}`;
        if (slidesShown > 1) {
            let numToAdd = slidesShown - 1;
            for (var i = 1; i <= numToAdd; i++) {
                let nextSlide = i;
                if (baseIndex + i <= indicatorsLength) {
                    nextSlide = baseIndex + i;
                }
                if (baseIndex + i > indicatorsLength) {
                    nextSlide = baseIndex + i - indicatorsLength;
                }
                slidesLabel += `, ${nextSlide}`;
            }
        }
        initIndicators.push(React__default['default'].createElement("button", { key: index, type: "button", "data-selected": index === 0 ? 'true' : 'false', "aria-current": index === 0 ? 'true' : 'false', className: clsx__default['default'](styles['indicator-button'], styles[indicatorStyle]), onClick: () => shiftSlide(index, 'indicator'), onKeyDown: (event) => {
                if (event.key === 'Enter') {
                    shiftSlide(index, 'indicator');
                }
            } },
            React__default['default'].createElement("span", { className: clsx__default['default'](styles['sr-only']), "aria-label": slidesLabel })));
    });
    return initIndicators;
}
function getControlButtons(controlsVisibility, controlClass, alignment, shiftSlide, direction, controlStyle, indicatorVisibility, disableControls, buttonDisabled) {
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("button", { disabled: buttonDisabled, "aria-hidden": disableControls || (controlsVisibility && 'true') || 'false', className: clsx__default['default'](styles['carousel-wrapper-control'], styles[direction], (disableControls || controlsVisibility) && styles['hidden'], disableControls && styles['disable-controls'], alignment, styles[controlStyle], !indicatorVisibility && styles['mt-adjust'], controlClass), onClick: (event) => {
                if (!disableControls) {
                    event.target.focus();
                    shiftSlide(direction === 'next' ? 1 : -1);
                }
            }, onKeyDown: (event) => {
                if (event.key === 'Enter') {
                    shiftSlide(direction === 'next' ? 1 : -1);
                }
            } },
            controlStyle === 'round' && (React__default['default'].createElement("svg", { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none" },
                React__default['default'].createElement("circle", { cx: "36", cy: "36", r: "35", transform: "rotate(-180 36 36)", fill: "white", stroke: "#2D2926" }),
                React__default['default'].createElement("path", { d: "M55.9997 35.5L17.0176 35.5", stroke: "#2D2926", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default['default'].createElement("path", { d: "M29.0176 47.5L17.0176 35.5L29.0176 23.5", stroke: "#2D2926", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
            React__default['default'].createElement("p", { className: clsx__default['default'](styles['sr-only']) }, direction === 'next' ? 'Move Slider Left Button' : 'Move Slider Right Button'))));
}
function getSlides(childrenArr, baseSlideCount, slidesShown, slideGrabbing, slideGap, flexBasis, margin, infinite, hasChips, hasDynamicWidth) {
    const initSlides = childrenArr === null || childrenArr === void 0 ? void 0 : childrenArr.map((child, index) => {
        if (React.isValidElement(child)) {
            let label = `slide ${index + 1} of ${baseSlideCount}`;
            return (React__default['default'].createElement("div", { "aria-label": label, "aria-hidden": slidesShown - 1 < index, key: label, className: clsx__default['default'](styles['slide'], slideGrabbing && styles['grabbing'], slideGap === 0 && styles['marginless'], hasChips && styles['chip-slide']), style: Object.assign(Object.assign({}, child.props.style), { flexBasis: `${flexBasis}%`, margin: hasDynamicWidth ? `0 ${margin}px 0 0` : `0 ${margin}%` }) }, React.cloneElement(child, {
                key: index
            })));
        }
    });
    // Configure infinite slider
    if (infinite) {
        const initSlidesLength = initSlides.length;
        const firstSlides = initSlides.slice(0, slidesShown);
        const lastSlides = initSlides.slice(initSlidesLength - slidesShown, initSlidesLength);
        const cloneSlides = firstSlides.concat(lastSlides).map((child, index) => {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    key: -index - 100,
                    'aria-hidden': 'true'
                });
            }
        });
        initSlides.unshift(...cloneSlides.slice(cloneSlides.length - slidesShown));
        initSlides.push(...cloneSlides.slice(0, slidesShown));
    }
    return initSlides;
}
function updateIndicatorDots(indicatorCount, activeIndex, destinationIndex, indicatorRef, baseSlideCount) {
    if (indicatorRef.current && indicatorRef.current.children) {
        if (destinationIndex < 0) {
            destinationIndex = baseSlideCount + destinationIndex;
        }
        if (destinationIndex === indicatorCount) {
            destinationIndex = 0;
        }
        indicatorRef.current.children[activeIndex].ariaCurrent = 'false';
        indicatorRef.current.children[activeIndex].attributes['data-selected'].value = 'false';
        indicatorRef.current.children[destinationIndex].ariaCurrent = 'true';
        indicatorRef.current.children[destinationIndex].attributes['data-selected'].value = 'true';
    }
}
function updateSlideAttributes(infinite, activeIndex, destinationIndex, sliderRef, baseSlideCount, slidesShown) {
    const setSlideAttributes = (index, boundary, hidden) => {
        let positionAdj = infinite ? slidesShown : 0;
        for (let i = index; i < boundary; i++) {
            let pos1 = i + positionAdj;
            sliderRef.current.children[pos1].ariaHidden = hidden;
        }
    };
    const activeIndexBoundary = activeIndex + 1 + (slidesShown - 1);
    setSlideAttributes(activeIndex, activeIndexBoundary, true);
    if (destinationIndex > baseSlideCount - 1) {
        destinationIndex = 0;
    }
    else if (destinationIndex < 0) {
        destinationIndex = baseSlideCount - 1;
    }
    const destinationIndexBoundary = destinationIndex + 1 + (slidesShown - 1);
    setSlideAttributes(destinationIndex, destinationIndexBoundary, false);
}
function carouselHelper(settings) {
    const { autoSlide, capturePropagation, children, chips, controlAlignment, controlStyle, controlClass, disableControls, duration, hideControls, hideIndicators, indicatorStyle, layoutGap, responsive, variableWidth } = settings;
    let { itemsToShow, infinite, disableEndButtons, showHalfSlides } = settings;
    // Configure dynamic override(s)
    const hasChips = typeof chips !== 'undefined' && chips.list && chips.list.length > 0;
    const [hasDynamicWidth] = React.useState(variableWidth || hasChips);
    if (hasDynamicWidth) {
        itemsToShow = 1;
        infinite = false;
    }
    const [dynamicShiftEnabled, setDynamicShiftEnabled] = React.useState(false);
    const [dynamicWidthArray, setDynamicWidthArray] = React.useState([]);
    const [slideStageWidth, setSlideStageWidth] = React.useState(0);
    const [dynamicIndexLimit, setDynamicIndexLimit] = React.useState(-1);
    const [handlingWhitespace, setHandlingWhitespace] = React.useState(false);
    const [slidesLeftThreshold, setSlidesLeftThreshold] = React.useState(0);
    const [activeIndexThreshold, setActiveIndexThreshold] = React.useState(0);
    // Configure buttons
    const [alignment, setAlignment] = React.useState([
        styles[(controlAlignment + '').split(' ')[0]],
        styles[(controlAlignment + '').split(' ')[1]]
    ]);
    const [indicatorVisibility, setIndicatorVisibility] = React.useState(hasDynamicWidth || hideIndicators);
    const [indicatorStyling, setIndicatorStyling] = React.useState(indicatorStyle);
    const [controlsVisibility, setControlVisibility] = React.useState(hideControls);
    // Configure autoslide / infinite
    if (autoSlide)
        infinite = true;
    // Configure slide boundary vars
    const [childrenArr, setChildrenArray] = React.useState(getChildrenArr(children, chips));
    const [baseSlideCount] = React.useState(childrenArr.length);
    const [slidesShown, setSlidesShown] = React.useState(itemsToShow <= baseSlideCount ? itemsToShow : baseSlideCount);
    const [initLeftPos, setInitLeftState] = React.useState(0);
    // Configure base slides
    const slidesRef = React.useRef(null);
    const [slidesWidth, setSlidesWidth] = React.useState((baseSlideCount * 100) / slidesShown + (infinite ? 100 * 2 : 0));
    const [slidesTransition, setSlidesTransition] = React.useState('');
    const [slidesLeft, setSlidesLeft] = React.useState(0);
    const [slidesPxWidth, setSlidesPxWidth] = React.useState(0);
    const [slideGap, setSlideGap] = React.useState(layoutGap);
    const [slideMargin, setSlideMargin] = React.useState(layoutGap);
    const [slideFlexBasis, setSlideFlexBasis] = React.useState(100);
    const [slideGrabbing, setSlideGrabbing] = React.useState(false);
    const [slideShift, setSlideShift] = React.useState(0);
    const [ariaLive, setAriaLive] = React.useState('off');
    // Configure responsive settings
    const [windowWidth, setWindowWidth] = React.useState(0);
    const [responsiveSettings] = React.useState(responsive);
    const slides = React.useMemo(() => getSlides(childrenArr, baseSlideCount, slidesShown, slideGrabbing, slideGap, slideFlexBasis, slideMargin, infinite, hasChips, hasDynamicWidth), [
        childrenArr,
        chips,
        hasDynamicWidth,
        baseSlideCount,
        slidesShown,
        slideGrabbing,
        slideFlexBasis,
        slideMargin,
        slidesRef.current
    ]);
    // Configure slider drag/touch handling
    const [handleCapturing, setHandleCapturing] = React.useState(false);
    const [dragActive, setDragActive] = React.useState(false);
    const [dragAttempt, setDragAttempt] = React.useState(0);
    const [posInitial, setPosInitial] = React.useState(0);
    const [posX1, setPosX1] = React.useState(0);
    const [activeIndex, setActiveIndex] = React.useState(0);
    const [allowShift, setAllowShift] = React.useState(true);
    const [rightDisabled, setRightDisabled] = React.useState(false);
    const [leftDisabled, setLeftDisabled] = React.useState(false);
    const [snapshotActiveIndex, setSnapshotActiveIndex] = React.useState(activeIndex);
    const [snapshotSlidesLeft, setSnapshotSlidesLeft] = React.useState(slidesLeft);
    const [dynamicSlidePercentageArray, setDynamicSlidePercentageArray] = React.useState([]);
    const toSlidesPercentage = (pixelVal) => {
        let _width;
        if (slideGap === 0) {
            _width = slidesPxWidth;
        }
        else {
            let additionalWidth = infinite ? 100 * 2 : 0;
            let visibleWidth = (baseSlideCount * 100) / slidesShown;
            _width = ((visibleWidth + additionalWidth) / slidesWidth) * slidesPxWidth;
        }
        let percentage = ((pixelVal * slides.length) / (slidesShown * _width)) * 100;
        return percentage;
    };
    const setSnapshotThresholdDetails = (dynWidthArray) => {
        const lastIndex = dynWidthArray.length - 1;
        let thresholdDetected = false;
        for (let activeIndex = 0; activeIndex < lastIndex; activeIndex++) {
            const dynamicWidthArrayValue = dynWidthArray.slice(activeIndex + 1).reduce((partialSum, a) => partialSum + a, 0);
            const whitespace = slideStageWidth - dynamicWidthArrayValue;
            const hasWhitespace = whitespace > 0;
            if (thresholdDetected)
                return;
            if (hasWhitespace) {
                thresholdDetected = true;
                let dynamicSnapshotShift = 0;
                let dynamicSlidePercentageArray = [];
                let leftPosition = 0;
                const rightPosition = dynWidthArray.reduce((partialSum, currentValue, slideIndex) => {
                    let dynamicShift = getDynamicSlidePercentage(currentValue);
                    leftPosition = partialSum === 0 ? leftPosition : dynamicShift * -1 + leftPosition;
                    if (slideIndex === activeIndex) {
                        const adjustedShift = ((slideStageWidth - (dynWidthArray[slideIndex] - slideGap)) / slideStageWidth) * 100;
                        dynamicShift = adjustedShift * -1;
                        dynamicSnapshotShift = partialSum * -1;
                    }
                    dynamicSlidePercentageArray = [
                        ...dynamicSlidePercentageArray,
                        {
                            slideIndex,
                            leftPosition
                        }
                    ];
                    return dynamicShift + partialSum;
                }, 0);
                setSlidesLeftThreshold(rightPosition * -1);
                setActiveIndexThreshold(lastIndex);
                setSnapshotActiveIndex(activeIndex);
                setSnapshotSlidesLeft(dynamicSnapshotShift);
                setDynamicSlidePercentageArray(dynamicSlidePercentageArray);
            }
        }
    };
    const exceedsSliderBoundary = (dir, action, extraShift = 0) => {
        var _a;
        // If using variable width, non-infinite settings and going right
        if (variableWidth && !infinite && dir == 1) {
            setSlidesTransition('');
            let destinationIndex = action === 'drag' ? (_a = getSlideShiftDimensions(dir, extraShift)) === null || _a === void 0 ? void 0 : _a.indexShift : activeIndex + 1;
            const hasWhitespace = destinationIndex > snapshotActiveIndex;
            if (hasWhitespace) {
                setSlidesTransition('left .5s ease-out');
                setSlidesLeft(slidesLeftThreshold);
                setActiveIndex(activeIndexThreshold);
            }
            setHandlingWhitespace(hasWhitespace);
            return { detectedWhitespace: hasWhitespace, exceededBoundary: hasWhitespace };
        }
        const exceededBoundary = !infinite &&
            ((dir == -1 && activeIndex === 0) ||
                (dir == 1 && activeIndex >= baseSlideCount - 1 - (slidesShown > 1 ? slidesShown - 1 : 0)));
        return { detectedWhitespace: false, exceededBoundary };
    };
    const calculateEvenShift = (shiftingRight, shift, numberOfShifts) => {
        const extraSlideShift = shift * numberOfShifts * (shiftingRight ? -1 : 1);
        return { extraSlideShift, shift: shift * (shiftingRight ? -1 : 1) };
    };
    const calculateDynamicShift = React.useCallback((shiftingRight, numberOfShifts) => {
        const dynamicIndex = shiftingRight ? activeIndex : activeIndex - 1;
        let dynamicShift = getDynamicSlidePercentage(dynamicWidthArray[dynamicIndex]) * (shiftingRight ? -1 : 1);
        if (!showHalfSlides && dynamicIndex + 1 === dynamicWidthArray.length - 1) {
            const adjustedShift = ((slideStageWidth - (dynamicWidthArray[dynamicIndex] - slideGap)) / slideStageWidth) * 100;
            if (shiftingRight) {
                dynamicShift = dynamicShift + adjustedShift;
            }
            else {
                dynamicShift = dynamicShift - adjustedShift;
            }
        }
        let extraShiftPercent = 0;
        for (let n = 0; n < numberOfShifts; n++) {
            if (shiftingRight) {
                extraShiftPercent += getDynamicSlidePercentage(dynamicWidthArray[activeIndex + n + 1]);
            }
            else {
                extraShiftPercent += getDynamicSlidePercentage(dynamicWidthArray[activeIndex - n - 2]);
            }
        }
        if (extraShiftPercent !== 0 && shiftingRight)
            extraShiftPercent *= -1;
        return { dynamicShift, extraShiftPercent };
    }, [activeIndex, dynamicWidthArray]);
    const getSlideShiftDimensions = React.useCallback((direction, numberOfShifts) => {
        const shiftingRight = direction === 1; // right (1), left (-1)
        const indexShift = direction + activeIndex + (shiftingRight ? numberOfShifts : -numberOfShifts);
        if (hasDynamicWidth) {
            const { dynamicShift, extraShiftPercent } = calculateDynamicShift(shiftingRight, numberOfShifts);
            return { extraShiftPercent, indexShift, shiftPercent: dynamicShift };
        }
        else {
            const { extraSlideShift, shift } = calculateEvenShift(shiftingRight, slideShift, numberOfShifts);
            return { extraShiftPercent: extraSlideShift, indexShift, shiftPercent: shift };
        }
    }, [hasDynamicWidth, calculateDynamicShift]);
    const getHandleWhitespaceDimensions = (action) => {
        if (action === 'drag') {
            const { leftPosition, slideIndex } = dynamicSlidePercentageArray.reduce((prevSlide, currSlide) => {
                const { leftPosition } = currSlide;
                const { leftPosition: prevLeftPosition } = prevSlide;
                return Math.abs(leftPosition - slidesLeft) < Math.abs(prevLeftPosition - slidesLeft) ? currSlide : prevSlide;
            });
            return { leftPosition, slideIndex };
        }
        // action - control button
        // Set the destinationIndex to the slide that was shown BEFORE whitespace was detected going rightwards
        return { leftPosition: snapshotSlidesLeft, slideIndex: snapshotActiveIndex };
    };
    const shiftSlide = (dir, action, extraShift = 0) => {
        // Check if slide is in the middle of a transition
        if (slidesTransition && !handlingWhitespace)
            return;
        // Check if slide exceeds beginning/end boundaries by drag or control
        const { detectedWhitespace, exceededBoundary } = exceedsSliderBoundary(dir, action, extraShift);
        if (exceededBoundary && action !== 'indicator') {
            if (action !== 'drag')
                return;
            if (!detectedWhitespace) {
                setSlidesTransition('left .5s ease-out');
                setSlidesLeft(activeIndex === 0 ? initLeftPos : action ? posInitial : slidesLeft);
            }
            return;
        }
        let destinationIndex = dir;
        if (allowShift) {
            switch (true) {
                case action === 'indicator':
                    // dir is the exact index destination
                    let slideMultiplier = Math.abs(destinationIndex - activeIndex);
                    if (slideMultiplier === 0)
                        return;
                    // hasDynamicWidth, infinite not enabled,
                    let sliderLeftAdjustment = (activeIndex < destinationIndex ? -1 : 1) * slideShift * slideMultiplier;
                    setSlidesLeft(slidesLeft + sliderLeftAdjustment);
                    setActiveIndex(destinationIndex);
                    break;
                case action === 'drag':
                default:
                    if (hasDynamicWidth && !dynamicShiftEnabled)
                        return;
                    if (handlingWhitespace) {
                        const { leftPosition, slideIndex } = getHandleWhitespaceDimensions(action);
                        setSlidesLeft(leftPosition);
                        setActiveIndex(slideIndex);
                        setHandlingWhitespace(false);
                    }
                    else {
                        // dir is the direction: left (-1) or right (1)
                        const initPosition = action ? posInitial : slidesLeft;
                        if (!action) {
                            setPosInitial(initPosition);
                        }
                        const { extraShiftPercent, indexShift, shiftPercent } = getSlideShiftDimensions(destinationIndex, extraShift);
                        setSlidesLeft(initPosition + shiftPercent + extraShiftPercent);
                        destinationIndex = indexShift;
                        // Handle destination index overshot
                        if (destinationIndex < -1) {
                            destinationIndex = indicatorsLength + destinationIndex;
                        }
                        else if (destinationIndex > indicatorsLength) {
                            destinationIndex = destinationIndex - indicatorsLength;
                        }
                        setActiveIndex(destinationIndex);
                    }
                    break;
            }
            if (action != 'initialize')
                updateSlideAttributes(infinite, activeIndex, destinationIndex, slidesRef, baseSlideCount, slidesShown);
            if (!indicatorVisibility && indicatorRef.current && indicatorRef.current.children && action != 'initialize') {
                updateIndicatorDots(indicators.length, activeIndex, destinationIndex, indicatorRef, baseSlideCount);
            }
            setAriaLive('off');
            setSlidesTransition('left .3s ease-out');
        }
        setAllowShift(false);
    };
    // Event Handler: transitionend
    const handleIndexCheck = () => {
        setSlidesTransition('');
        setAriaLive('polite');
        if (activeIndex === -1) {
            let leftAdjustment = (baseSlideCount - slidesShown + (slidesShown - 1)) * slideShift;
            setSlidesLeft(initLeftPos - leftAdjustment);
            setActiveIndex(baseSlideCount - 1);
        }
        if (activeIndex === baseSlideCount && !handlingWhitespace) {
            setSlidesLeft(initLeftPos);
            setActiveIndex(0);
        }
        setAllowShift(true);
    };
    // Event Handler: mousedown
    const handleDragStart = (event) => {
        var _a;
        // Check if we are currently transitioning
        if (slidesTransition) {
            handleIndexCheck();
            if (dragAttempt < 1) {
                setDragAttempt(1);
                return;
            }
            setDragAttempt(0);
        }
        event = event || window.event;
        if (event.type !== 'touchstart') {
            event.preventDefault();
            document.activeElement.blur();
        }
        event.stopPropagation();
        setPosInitial(slidesLeft);
        if (event.type == 'touchstart') {
            setPosX1(toSlidesPercentage((_a = event.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX));
        }
        else {
            setPosX1(toSlidesPercentage(event.clientX));
        }
        document.body.style.cursor = 'grabbing';
        setSlideGrabbing(true);
        setDragActive(true);
    };
    // Event Handler: mouseover
    const handleDragActionHandler = React.useCallback((event) => {
        var _a, _b;
        if (dragActive) {
            event = event || window.event;
            var nextPosition = 0;
            if (event.type == 'touchmove') {
                nextPosition = posX1 - toSlidesPercentage((_a = event.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX);
                setPosX1(toSlidesPercentage((_b = event.touches[0]) === null || _b === void 0 ? void 0 : _b.clientX));
            }
            else {
                nextPosition = posX1 - toSlidesPercentage(event.clientX);
                setPosX1(toSlidesPercentage(event.clientX));
            }
            if (infinite && slidesLeft > 0) {
                setSlidesLeft(-slideShift * baseSlideCount);
            }
            else if (infinite && slidesLeft < -(slideShift * baseSlideCount) - 100) {
                setSlidesLeft(-100);
            }
            else {
                setSlidesLeft(slidesLeft - nextPosition);
            }
            if (capturePropagation === 'allow') {
                setHandleCapturing(true);
            }
        }
    }, [dragActive, posInitial, slidesLeft, handlingWhitespace]);
    // Event Handler: mouseup
    const handleDragEndHandler = React.useCallback((event) => {
        if (dragActive) {
            // (B) Fixing variableWidth boundary issue
            let { diff, extraSlides, threshold } = getBoundaryProps();
            if (diff < -threshold) {
                if (!infinite)
                    extraSlides = boundaryCheck(1, extraSlides);
                shiftSlide(1, 'drag', extraSlides);
            }
            else if (diff > threshold) {
                if (!infinite)
                    extraSlides = boundaryCheck(-1, extraSlides);
                shiftSlide(-1, 'drag', extraSlides);
            }
            else {
                setSlidesLeft(posInitial);
            }
            document.body.style.cursor = 'default';
            setSlideGrabbing(false);
            setDragActive(false);
        }
    }, [dragActive, posInitial, slidesLeft, activeIndex, hasDynamicWidth, handlingWhitespace]);
    const handleClickViaCapturing = React.useCallback((event) => {
        if (handleCapturing) {
            event.stopPropagation();
            setHandleCapturing(false);
        }
    }, [handleCapturing]);
    const getDynamicSlidePercentage = (width) => {
        return (width / slideStageWidth) * 100;
    };
    const getDynamicBoundaryProps = (diff) => {
        const currentLengthPercent = getDynamicSlidePercentage(dynamicWidthArray[activeIndex]);
        // the currentLengthPercent / # (The higher # is the less dragging and more "flick" like the touchstart/end is)
        const currentThreshold = currentLengthPercent / 20;
        let direction = 'right';
        if (diff > currentThreshold)
            direction = 'left';
        let absDiff = Math.abs(diff);
        let dynamicIndex = activeIndex;
        let dynamicThreshold = currentThreshold;
        let dynamicPercent = currentLengthPercent;
        let extraSlides = 0;
        for (let i = dynamicPercent; i < absDiff; i = i + dynamicPercent) {
            if (i - dynamicThreshold <= absDiff && absDiff <= i + dynamicThreshold) {
                break; // threshold is exceeding, quit adding extra slides
            }
            if (direction === 'right' && activeIndex + 1 + extraSlides > dynamicIndexLimit) {
                break; // boundary is exceeding, quit adding extra slides
            }
            dynamicIndex = dynamicIndex + (direction === 'right' ? 1 : -1);
            extraSlides++;
            dynamicPercent = getDynamicSlidePercentage(dynamicWidthArray[dynamicIndex]);
            // the deynamicPercent / # (The higher # is the less dragging and more "flick" like the touchstart/end is)
            dynamicThreshold = dynamicPercent / 20;
        }
        return {
            additionalSlides: extraSlides,
            currentThreshold,
            direction,
            limitExceeded: false
        };
    };
    const getEvenBoundaryProps = (diff, shift, threshold) => {
        let extraSlides = 0;
        let absDiff = Math.abs(diff);
        for (let i = 0; i < absDiff; i = i + shift) {
            if (i - threshold <= absDiff && absDiff <= i + threshold) {
                break;
            }
            extraSlides++;
        }
        return extraSlides - 1;
    };
    const getBoundaryProps = () => {
        var posFinal = slidesLeft;
        let diff = posFinal - posInitial;
        let threshold = 0;
        let extraSlides = 0;
        if (hasDynamicWidth) {
            if (!dynamicShiftEnabled)
                diff = 0;
            else {
                const { additionalSlides, currentThreshold, direction } = getDynamicBoundaryProps(diff);
                if (direction === 'right' && activeIndex === dynamicIndexLimit + 1) {
                    diff = 0;
                }
                extraSlides = additionalSlides;
                threshold = currentThreshold;
            }
        }
        else {
            // the slideShift / # (The higher # is the less dragging and more "flick" like the touchstart/end is)
            threshold = slideShift / 20;
            extraSlides = getEvenBoundaryProps(diff, slideShift, threshold);
        }
        return { diff, extraSlides, threshold };
    };
    const boundaryCheck = (dir, extraSlides) => {
        let destinationIndex = dir + activeIndex + dir * extraSlides;
        if (destinationIndex <= -1) {
            var limit = dir + activeIndex;
            return limit > 0 ? limit : 0;
        }
        if (destinationIndex >= indicatorsLength) {
            var limit = indicatorsLength - 1 - activeIndex - 1;
            return limit > 0 ? limit : 0;
        }
        return extraSlides;
    };
    // Configure slider indicators
    const indicatorsLength = React.useMemo(() => getNumberOfIndicators(baseSlideCount, slidesShown, infinite), [baseSlideCount, slidesShown, infinite]);
    const indicatorRef = React.useRef(null);
    const indicators = React.useMemo(() => getIndicators(indicatorsLength, baseSlideCount, slidesShown, childrenArr, indicatorStyling, shiftSlide), [activeIndex, slidesTransition, slidesLeft, slideShift]);
    React.useEffect(() => {
        if (!infinite && disableEndButtons) {
            setLeftDisabled(!infinite && activeIndex === 0);
            setRightDisabled(!infinite && activeIndex >= baseSlideCount - 1 - (slidesShown > 1 ? slidesShown - 1 : 0));
        }
    }, [activeIndex]);
    const controlButtons = [];
    controlButtons.push(getControlButtons(controlsVisibility, controlClass, alignment, shiftSlide, 'prev', controlStyle, indicatorVisibility, disableControls, leftDisabled));
    controlButtons.push(getControlButtons(controlsVisibility, controlClass, alignment, shiftSlide, 'next', controlStyle, indicatorVisibility, disableControls, rightDisabled));
    React.useEffect(() => {
        document.addEventListener('mouseup', handleDragEndHandler);
        document.addEventListener('mousemove', handleDragActionHandler);
        return () => {
            document.removeEventListener('mouseup', handleDragEndHandler);
            document.removeEventListener('mousemove', handleDragActionHandler);
        };
    }, [handleDragEndHandler, handleDragActionHandler]);
    React.useEffect(() => {
        if (autoSlide && !dragActive) {
            let timer;
            clearInterval(timer);
            timer = setInterval(() => {
                shiftSlide(1);
            }, duration);
            return () => clearInterval(timer);
        }
    }, [activeIndex, dragActive, allowShift, slidesLeft]);
    // useWindowResizeMeasurements
    React.useEffect(() => {
        function handleResize() {
            const { current } = slidesRef;
            const measurements = __rest(getSliderMeasurements(current, slideGap, infinite, showHalfSlides, baseSlideCount, slidesShown, hasDynamicWidth), []);
            setInitLeftState(measurements.slidesLeft);
            setSlidesLeft(measurements.slidesLeft);
            setSlidesPxWidth(measurements.slidesPxWidth);
            setSlideShift(measurements.slideShift);
            setSlideMargin(measurements.slideMargin);
            setSlideFlexBasis(measurements.slideFlexBasis);
            setSlideStageWidth(measurements.slidePxWidth);
            setDynamicShiftEnabled(measurements.dynamic.shiftEnabled);
            setDynamicWidthArray(measurements.dynamic.lengthArray);
            setDynamicIndexLimit(measurements.dynamic.dynamicIndexLimit);
            if (hasDynamicWidth) {
                setActiveIndex(0);
            }
            setWindowWidth(window.innerWidth);
            if (responsiveSettings.length) {
                let possibleSettings = responsiveSettings.filter((settings) => window.innerWidth <= settings.breakpoint);
                let newSettings = null;
                if (possibleSettings.length) {
                    newSettings = possibleSettings.reduce((min, settings) => min.breakpoint < settings.breakpoint ? min : settings);
                }
                if (newSettings) {
                    if ('itemsToShow' in newSettings) {
                        let newItemsToShow = baseSlideCount ? newSettings.itemsToShow : baseSlideCount;
                        setSlidesShown(newItemsToShow);
                        setSlidesWidth((baseSlideCount * 100) / newItemsToShow + (infinite ? 100 * 2 : 0));
                    }
                    if ('controlAlignment' in newSettings) {
                        setAlignment([
                            styles[(newSettings.controlAlignment + '').split(' ')[0]],
                            styles[(newSettings.controlAlignment + '').split(' ')[1]]
                        ]);
                    }
                    if ('hideControls' in newSettings) {
                        setControlVisibility(newSettings.hideControls);
                    }
                    if ('hideIndicators' in newSettings) {
                        setIndicatorVisibility(hasDynamicWidth || newSettings.hideIndicators);
                    }
                    if ('indicatorStyle' in newSettings) {
                        setIndicatorStyling(newSettings.indicatorStyle);
                    }
                    if ('layoutGap' in newSettings) {
                        setSlideGap(newSettings.layoutGap);
                    }
                }
                else {
                    setSlidesShown(itemsToShow);
                    setSlidesWidth((baseSlideCount * 100) / itemsToShow + (infinite ? 100 * 2 : 0));
                    setAlignment([styles[(controlAlignment + '').split(' ')[0]], styles[(controlAlignment + '').split(' ')[1]]]);
                    setControlVisibility(hideControls);
                    setIndicatorVisibility(hasDynamicWidth || hideIndicators);
                    setIndicatorStyling(indicatorStyle);
                    setSlideGap(layoutGap);
                }
            }
            setSnapshotThresholdDetails(measurements.dynamic.lengthArray);
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [windowWidth]);
    React.useEffect(() => {
        setChildrenArray(getChildrenArr(children, chips));
    }, [children, chips]);
    React.useEffect(() => {
        const { current } = slidesRef;
        const measurements = __rest(getSliderMeasurements(current, slideGap, infinite, showHalfSlides, baseSlideCount, slidesShown, hasDynamicWidth), []);
        setInitLeftState(measurements.slidesLeft);
        setSlidesLeft(measurements.slidesLeft);
        setSlidesPxWidth(measurements.slidesPxWidth);
        setSlideShift(measurements.slideShift);
        setSlideMargin(measurements.slideMargin);
        setSlideFlexBasis(measurements.slideFlexBasis);
        setSnapshotThresholdDetails(measurements.dynamic.lengthArray);
        setAriaLive('polite');
    }, [windowWidth]);
    return {
        slidesRef,
        slidesLeft,
        slides,
        slidesWidth,
        indicators,
        controlButtons,
        indicatorVisibility,
        indicatorRef,
        slidesTransition,
        ariaLive,
        handleDragStart,
        handleDragEndHandler,
        handleDragActionHandler,
        handleIndexCheck,
        handleClickViaCapturing
    };
}

const Carousel = ({ ariaLabel, autoSlide = false, capturePropagation = 'allow', carouselClass, chips = undefined, children, controlAlignment = 'middle apart', controlClass = '', controlStyle = 'square', disableControls = false, duration = 3000, hideControls = false, hideIndicators = false, disableEndButtons = false, indicatorStyle = 'round', indicatorBg = 'light', itemsToShow = 1, showHalfSlides = false, layoutGap = 0, infinite = false, responsive = [{}], variableWidth = false }) => {
    const helperSettings = {
        autoSlide,
        capturePropagation,
        children,
        chips,
        controlAlignment,
        controlClass,
        controlStyle,
        disableControls,
        duration,
        hideControls,
        hideIndicators,
        disableEndButtons,
        indicatorStyle,
        infinite,
        itemsToShow,
        showHalfSlides,
        layoutGap,
        //@ts-ignore
        responsive,
        variableWidth
    };
    const { slidesRef, slidesLeft, slides, slidesWidth, indicators, controlButtons, indicatorVisibility, indicatorRef, slidesTransition, ariaLive, handleDragStart, handleDragEndHandler, handleDragActionHandler, handleIndexCheck, handleClickViaCapturing } = carouselHelper(helperSettings);
    const screenReaderInstructions = (React__default['default'].createElement("p", { className: clsx__default['default'](styles['sr-only']) },
        "This is a draggable carousel",
        autoSlide && 'It has auto-rotating slides',
        "Use Next and Previous buttons to navigate.",
        !indicatorVisibility && 'You can also jump to a slide using the slide dots.'));
    const indicatorWrapper = (React__default['default'].createElement("div", { ref: indicatorRef, className: clsx__default['default'](styles['carousel-wrapper-indicators'], indicatorBg == 'dark' && styles['dark']) }, !indicatorVisibility && indicators));
    const template = (React__default['default'].createElement("section", { className: clsx__default['default'](styles['carousel-wrapper'], styles['loaded'], styles['carousel-chips'], carouselClass), "aria-label": 'carousel-' + ariaLabel },
        screenReaderInstructions,
        controlButtons[0],
        React__default['default'].createElement("div", { className: styles['carousel-wrapper-slider'] },
            React__default['default'].createElement("div", { className: styles['carousel-wrapper-slides'], "aria-live": ariaLive, style: {
                    left: `${slidesLeft}%`,
                    width: `${slidesWidth}%`,
                    transition: slidesTransition,
                    WebkitTransition: slidesTransition,
                    MozTransition: slidesTransition,
                    msTransition: slidesTransition,
                    OTransition: slidesTransition
                }, ref: slidesRef, onClickCapture: handleClickViaCapturing, onMouseDown: handleDragStart, onTouchStart: handleDragStart, onTouchEnd: handleDragEndHandler, onTouchMove: handleDragActionHandler, onTouchCancel: handleIndexCheck, onTransitionEnd: handleIndexCheck }, slides),
            !indicatorVisibility && indicatorWrapper),
        controlButtons[1]));
    return template;
};

module.exports = Carousel;
